import { Component } from '@angular/core';

@Component({
  selector: 'app-page-header',
  styleUrls: ['./page-header.component.scss'],
  template: '<h1 class="text-ui-dark text-2xl font-semibold mb-0"><ng-content></ng-content></h1>',
})
export class PageHeaderComponent {
}
